<div class="main" [ngClass]="{'dark-theme': isDarkTheme | async}">
  <app-header></app-header>
  <app-overlay></app-overlay>
  <app-loader></app-loader>
  <main id="main-container-wrapper" 
    [@routeAnimations]="{
      value: o.isActivated ? o.activatedRoute : '',
      params: { transform : outletTransform,
                position : position }
    }"   
    [ngClass]="{'is-touch-device':touchDevice || isIPadPro }" >
    <router-outlet  #o="outlet"></router-outlet>
  </main>
</div>

<div class="go-to-top-wrapper" [ngClass]="{'animate':showButton}">
  <div><a class="link1-mobile link-athensgray" (click)="goToTop()">Go to top</a></div>
</div>

